import { render, staticRenderFns } from "./v-overlay.vue?vue&type=template&id=fdd8e1a8&scoped=true"
import script from "./v-overlay.vue?vue&type=script&lang=js"
export * from "./v-overlay.vue?vue&type=script&lang=js"
import style0 from "./v-overlay.vue?vue&type=style&index=0&id=fdd8e1a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd8e1a8",
  null
  
)

export default component.exports